/*
 * Lepivá lišta "do košíku" pro mobil.
 *
 * Vestavěná sekce sticky-cart tématu Pharm se použít nedá — hledá si
 * .product-info / product-form / .button-add-to-cart z původní produktové
 * sekce, zatímco naše PDP jede na ilico-evo-product-main.
 *
 * Proto lišta nic nesimuluje: jen zrcadlí cenu a klik posílá na skutečné
 * tlačítko. Výběr varianty, množství i AJAX tak zůstávají v jedné logice.
 */
(function () {
  'use strict';
  if (window._ilicoStickyBuy) return;
  window._ilicoStickyBuy = true;

  function init() {
    var bar = document.querySelector('[data-ilico-stickybuy]');
    var cta = document.querySelector('[data-evo-add]');
    if (!bar || !cta) return;

    var btn = bar.querySelector('[data-stickybuy-add]');
    var cenaEl = bar.querySelector('[data-stickybuy-price]');
    var zdrojCeny = document.querySelector('[data-evo-price]');
    var compareEl = bar.querySelector('[data-stickybuy-compare]');
    /* Zdroj přeškrtnuté ceny se nedrží: u varianty, která při načtení
       stránky v akci není, ho produktová sekce v DOM vůbec nemá a tvoří
       si ho až při přepnutí na zlevněnou variantu. */
    function zdrojCompare() {
      return document.querySelector('[data-evo-compare]');
    }

    /* POZOR: tlačítko košíku se při přepnutí varianty v DOM vyměňuje.
       Nic z něj si proto nedržíme — při kliku i synchronizaci se dohledá
       znovu. Držený odkaz na odpojený uzel dřív způsobil, že se lišta
       nikdy neukázala (rect odpojeného uzlu je samá nula) a klik mířil
       do prázdna. */
    function aktualniCta() {
      return document.querySelector('[data-evo-add]') || cta;
    }

    /* Klik jen přepošleme — veškerá logika zůstává na původním tlačítku. */
    btn.addEventListener('click', function () {
      aktualniCta().click();
    });

    function synchronizuj() {
      if (zdrojCeny && cenaEl) cenaEl.textContent = zdrojCeny.textContent.trim();
      if (compareEl) {
        var zdroj = zdrojCompare();
        /* Skrytý zdroj znamená „varianta mimo akci" — produktová sekce
           element nemaže, jen ho schová. */
        var naAkci = zdroj && !zdroj.hidden && zdroj.textContent.trim();
        if (naAkci) {
          compareEl.textContent = zdroj.textContent.trim();
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var aktualni = aktualniCta();
      var loading = aktualni.dataset.loading === 'true' || aktualni.classList.contains('loading');
      var vypnuto = aktualni.hasAttribute('disabled');
      btn.disabled = loading || vypnuto;
      btn.setAttribute('aria-busy', String(loading));
      btn.textContent = loading
        ? (aktualni.textContent.includes('✓') ? aktualni.textContent.trim() : 'Přidávám…')
        : vypnuto ? 'Není skladem' : 'Do košíku';
    }

    synchronizuj();

    /* Cena i dostupnost se mění při přepnutí varianty. Atributy hlídáme
       přes rodiče se subtree — samotné tlačítko se může vyměnit. */
    if (window.MutationObserver) {
      var mo = new MutationObserver(synchronizuj);
      if (zdrojCeny) mo.observe(zdrojCeny, { childList: true, characterData: true, subtree: true });
      /* Přeškrtnutá cena vzniká jako sourozenec ceny hlavní, takže její
         přidání ani skrytí by sledování samotné ceny nezachytilo. */
      var cenovyBlok = zdrojCeny && zdrojCeny.parentElement;
      if (cenovyBlok) {
        mo.observe(cenovyBlok, {
          childList: true, characterData: true, subtree: true,
          attributes: true, attributeFilter: ['hidden'],
        });
      }
      var obal = cta.closest('.ilico-evo-p__buy') || cta.parentElement || cta;
      mo.observe(obal, { attributes: true, attributeFilter: ['disabled', 'data-loading', 'class'], subtree: true, childList: true });
    }

    /* Lišta se ukáže, až nákupní řádek odscrolluje z obrazovky.
       Sledujeme stabilní obal řádku, ne vyměnitelné tlačítko. */
    if (window.IntersectionObserver) {
      var sentinel = cta.closest('.ilico-evo-p__buy') || cta;
      new IntersectionObserver(function (zaznamy) {
        zaznamy.forEach(function (z) {
          bar.classList.toggle('is-visible', !z.isIntersecting && z.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(sentinel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
